export type PackId = 'single' | 'trio' | 'crew'

const EVENT = 'gritvue:select-offer'

/**
 * Lets any CTA lower on the page preselect the pack it argues for, so the
 * visitor lands in the offer section with the right card already chosen
 * instead of hunting for the product again.
 */
export function requestOffer(id: PackId) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent<PackId>(EVENT, { detail: id }))
}

export function onOfferRequest(handler: (id: PackId) => void) {
  const listener = (event: Event) => handler((event as CustomEvent<PackId>).detail)
  window.addEventListener(EVENT, listener)
  return () => window.removeEventListener(EVENT, listener)
}
